import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=0abc4b82&scoped=true&"
import script from "./academy.vue?vue&type=script&lang=js&"
export * from "./academy.vue?vue&type=script&lang=js&"
import style0 from "./academy.vue?vue&type=style&index=0&id=0abc4b82&prod&lang=scss&"
import style1 from "./academy.vue?vue&type=style&index=1&id=0abc4b82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc4b82",
  null
  
)

export default component.exports